import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { Query, graphql, compose } from 'react-apollo'
import assign from 'lodash/assign'
import moment from 'moment'
import get from 'lodash/get'
import cn from 'classnames'
import Logo from '../common/Logo'
import { PDFExport} from '@progress/kendo-react-pdf';
// import { Loader } from '../../containers/Loader'
import { QUESTIONS_PER_PAGE } from '../../config'
import { QUESTIONS_ORDER_RECENT, QUESTIONS_ORDER_UPVOTED } from '../../constants'
// import Count from '../common/Count'
import TimeAgo from '../common/TimeAgo'
import BOARD_QUERY from '../../graphql/BoardDetailQuery.graphql'
import ARCHIVE_BOARD_MUTATION from '../../graphql/mutations/ArchiveBoardMutation.graphql'
import REMIND_BOARD_MUTATION from '../../graphql/mutations/RemindBoardMutation.graphql'
import Questions from '../Questions'
import { getPageTitle, submissionsClosed } from '../../utils'
import ChangeSubmission from './ChangeSubmission'
import AskQuestion from './AskQuestion'
import NotFound from '../404'
// import AddComment from "./AddComment";
// import { getUser } from '../../utils'

// import styles from './Board.module.css'

class Board extends Component {
  state = {
    orderBy: QUESTIONS_ORDER_RECENT,
    remindedState: 'initial',
    pdfExportComponent: null
  }

  handleChangeOrder = (e, orderBy) => {
    e.preventDefault()
    this.setState({ orderBy })
  }

    exportPDFWithComponent = () => {
        this.state.pdfExportComponent.save();
    }


  handleArchive = uuid => {
    this.props.archiveBoard({
      variables: {
        uuid: uuid,
      },
      optimisticResponse: {
        __typename: 'Mutation',
        archiveBoard: {
          __typename: 'Archive',
          success: true,
          board: {
            uuid,
            __typename: 'Board',
            isArchived: true,
          },
        },
      },
    })
  }

  renderArchived = board => {
    const { uuid, isArchived } = board
    if (isArchived) {
      // return <span className="badge badge-pill badge-warning">Archived</span>
        return <div className="alert alert-warning jelly-smart-alert d-inline-block" role="alert">Archived</div>
    }
    return (
        <div className="">
          <button className="btn btn-primary btn-block" onClick={() => this.handleArchive(uuid)}>
            <i className="fa fa-archive" /><span className="ml-2">Archive Board</span>
          </button>
        </div>
    )
  }

  handleRemindBoard = async uuid => {
    if (this.state.remindedState === 'in-progress') {
      return
    }
    this.setState({
      remindedState: 'in-progress',
    })
    const result = await this.props.remindBoard({
      variables: {
        uuid: uuid,
      },
    })
    if (get(result, 'data.remindBoard.success')) {
      this.setState({
        remindedState: 'reminded',
      })
    } else {
      alert('Failed to remind channel of board. Please try again or contact support.')
    }
  }

  renderRemind = board => {
    const { uuid } = board
    const { remindedState } = this.state
    const isReminding = remindedState === 'in-progress'
    const isReminded = remindedState === 'reminded'
    return (
        <div>
          <button
            className="btn btn-primary btn-block"
            onClick={() => this.handleRemindBoard(uuid)}
          >
        <span className={cn({ 'd-none': !isReminding })}>
          <i className="fa fa-spinner fa-spin" />
        </span>
        <span className={cn({ 'd-none': isReminded || isReminding })}>
          <i className="fa fa-bell" />
        </span>
        <span className={cn({ 'd-none': !isReminded })}>
          <i className="fa fa-check-circle" />
        </span>
        <span className="ml-2">
          {/*Remind <b>#{board.slackChannelName}</b>*/}
            Remind Channel
        </span>
      </button>

        </div>
    )
  }

  renderModeratorInfo = board => {
    return (
        <div className="col-sm-6 col-md-3 col-lg-2 pb-2">
            {submissionsClosed(board) && this.renderArchived(board) }
            {!submissionsClosed(board) && this.renderRemind(board) }

        </div>
    )
  };

  render() {
    const boardId = this.props.match.params.id
    const { orderBy } = this.state

    return (
      <Query
        query={BOARD_QUERY}
        variables={{
          id: `Board:${boardId}`,
          first: QUESTIONS_PER_PAGE,
          orderBy: orderBy,
        }}
      >
        {({ loading, data, fetchMore, refetch}) => {

          if (loading) {
            // return <Loader />
              return null
          }
          else if (!data.getBoard) {
                return <NotFound/>
          }

          const pageInfo = get(data, 'getBoard.questions.pageInfo', {})
          const {
            uuid,
            topic,
            description,
            questionCount,
            isModerator,
            submissionEndDate,
            creator,
            permalink,
            slackChannelName,
            isArchived,
            created
          } = data.getBoard
          return (
              <DocumentTitle title={getPageTitle()}>
            {/*<DocumentTitle title={getPageTitle(topic)}>*/}
            {/*  <div className="pt-4">*/}
                  {/*<PDFExport ref={(component) => this.state.pdfExportComponent = component} paperSize="Letter" landscape={false} scale={0.5} top="5cm" margin="5mm" fileName={"Jellyfish-"+topic}>*/}
                  <div className="container py-4 mb-3">
                  {/*<div className="container py-4 mb-4">*/}
                      <div className="card">
                      <PDFExport ref={(component) => this.state.pdfExportComponent = component}
                                 paperSize="Letter"
                                 landscape={false}
                                 scale={0.5}
                                 margin={{top:"10mm",left:"15mm", right:"15mm", bottom:"10mm"}}
                                 fileName={"Jellyfish-"+topic+".pdf"}
                                 creator="https://www.jellyfish.chat"
                                 author={creator.slackRealName}
                                 producer="Jellyfish App"
                                 subject="Q&A Session"
                                 title={topic}
                                 keepTogether=".question-row"
                      >


                        <div className="card-header pb-4 jelly-card-header p-4">
                            <div className="float-right pdf-export-only">
                                <Logo/>
                                <div className="my-2"><a href="https://www.jellyfish.chat">www.jellyfish.chat</a></div>
                                {/*<div className="my-2 text-muted">{moment(created).format('MMMM Do YYYY')}</div>*/}
                                {/*<div className="row"></div>*/}
                            </div>
                            <div className="pdf-export-only"><h4><a href={`/board/${uuid}`}>{topic}</a>&nbsp;&nbsp;&nbsp;<a target="_blank" className="jelly-pointer" title="Open in Slack" href={permalink}><i className="fas fa-external-link-alt text-secondary small" /></a></h4></div>
                            <div className="pdf-no-export"><h4>{topic}&nbsp;&nbsp;&nbsp;<a target="_blank" className="jelly-pointer" title="Open in Slack" href={permalink}><i className="fas fa-external-link-alt text-secondary small" /></a></h4></div>
                              {/*<span><a href={permalink}>Open in Slack</a></span>*/}
                          {/*</div>*/}
                          {/*<div className="text-muted">{description}</div>*/}
                            <div className="text-muted">{description}</div>
                            <div className="text-muted my-2"><span className="">{creator.slackRealName} in #{slackChannelName}</span>
                            <span className="pdf-no-export"> - <TimeAgo date={created} /></span>
                            <span className="my-2 pdf-export-only">{moment(created).format('MMMM Do YYYY')}</span>
                          </div>
                          <div className="pb-3 pdf-no-export">
                              <div className="alert alert-warning jelly-smart-alert d-inline-block" role="alert">
                                {submissionsClosed(data.getBoard)
                                    ? 'Submissions Closed: '
                                    : 'Submissions Close: '}
                                  <TimeAgo date={submissionEndDate} />
                              </div>
                          </div>
                          <div className="row pdf-no-export">
                               {!submissionsClosed(data.getBoard) && (<AskQuestion board={data.getBoard} onCloseRefreshHandler={() => refetch()} />)}
                                {isModerator && (<ChangeSubmission board={data.getBoard} />)}
                              {isModerator && (
                                  <div className="d-sm-down-none col-sm-6 col-md-3 col-lg-2 pb-2">
                                      <button className="btn btn-primary btn-block px-3" onClick={this.exportPDFWithComponent}>
                                          {/*<i className="fa fa-file-pdf"/><span className="ml-1"> Export PDF</span>*/}
                                          <i className="fa fa-file-pdf"/><span className="ml-2">Export PDF</span>
                                      </button>
                                  </div>
                              )}
                              {isModerator && this.renderModeratorInfo(data.getBoard)}
                              {/*<div className="col-sm-6 col-md-3 col-lg-2 pb-2">*/}
                              {/*  {isModerator && !submissionsClosed(data.getBoard) && data.getBoard.submissionEndRemindedOn && (*/}
                              {/*    <span>*/}
                              {/*    <small className="text-muted">*/}
                              {/*        <i>Reminded:<TimeAgo date={data.getBoard.submissionEndRemindedOn} /></i>*/}
                              {/*    </small>*/}
                              {/*  </span>*/}
                              {/*  )}*/}
                              {/*</div>*/}
                          </div>
                        </div>

                        <div className="card-body">

                          {/* card body put questions here*/}
                            <div className="d-flex flex-row align-items-center justify-content-between">
                                <div className="p-2 col-6"><h4>Questions <span className="pdf-no-export d-sm-down-none">{isModerator && ("("+questionCount+")")}</span></h4></div>

                                {questionCount > 1 && (
                                    <div className="p-2 col-6">
                                        {/*<div className="p-2">Order By</div>*/}
                                        <div aria-label="First group" role="group" className="btn-group float-right pdf-no-export">
                                            {/*<span className="p-2">Order By</span>*/}
                                            <button type="button"
                                                    onClick={e => this.handleChangeOrder(e, QUESTIONS_ORDER_RECENT)}
                                                    className={cn(
                                                        'btn btn-outline-primary question-btn-outline-primary',
                                                        orderBy === QUESTIONS_ORDER_RECENT && 'active'
                                                    )}>Recent</button>
                                            <button type="button"
                                                    onClick={e => this.handleChangeOrder(e, QUESTIONS_ORDER_UPVOTED)}
                                                    className={cn(
                                                        'btn btn-outline-primary question-btn-outline-primary ',
                                                        orderBy === QUESTIONS_ORDER_UPVOTED && 'active'
                                                    )}>Upvoted</button>
                                        </div>
                                    </div>
                                ) }

                            </div>

                                <Questions
                                    edges={get(data, 'getBoard.questions.edges', [])}
                                    pageInfo={pageInfo}
                                    board={data.getBoard}
                                    boardRefreshHandler={() => refetch()}
                                    onLoadMore={() =>
                                        fetchMore({
                                            variables: {
                                                id: `Board:${boardId}`,
                                                after: pageInfo.endCursor,
                                                first: QUESTIONS_PER_PAGE,
                                                orderBy: orderBy,
                                            },
                                            updateQuery: (prev, { fetchMoreResult }) => {
                                                if (!fetchMoreResult) return prev
                                                // Merge the edges together, but keep the new pageInfo
                                                return assign({}, prev, {
                                                    getBoard: {
                                                        ...prev.getBoard,
                                                        questions: {
                                                            ...prev.getBoard.questions,
                                                            pageInfo: fetchMoreResult.getBoard.questions.pageInfo,
                                                            edges: [
                                                                ...prev.getBoard.questions.edges,
                                                                ...fetchMoreResult.getBoard.questions.edges,
                                                            ],
                                                        },
                                                    },
                                                })
                                            },
                                        })
                                    }
                                />
                                {/*{loading ? <Loader /> : null}*/}
                        </div>
                        {/*<div className="card-footer">footer</div>*/}
                      </PDFExport>
                      </div>
                  </div>
                {/*<div className="bg-light">*/}

                {/*</div>*/}
              {/*</div>*/}
            </DocumentTitle>
          )
        }}
      </Query>
    )
  }
}

export default compose(
  graphql(ARCHIVE_BOARD_MUTATION, {
    name: 'archiveBoard',
  }),
  graphql(REMIND_BOARD_MUTATION, {
    name: 'remindBoard',
  })
)(Board)



// WEBPACK FOOTER //
// ./src/components/Board/index.jsx